module.exports = __webpack_public_path__ + "img/sdc2018_5.59d3caed.png";